import * as React from "react";
import { Game, IGameSave } from "./Game";
import { IAppState } from "./App";

export interface ISaveGameProps {
    state: IAppState;
    onClose: () => void;
}
export class SaveGameComponent extends React.Component<ISaveGameProps, any> {
    save(index: number) {
        const d = new Date();
        const save: IGameSave = { state: this.props.state, date: d.toLocaleDateString() + " " + d.toLocaleTimeString(), name: "default" };
        if (index < 0) {
            Game.addSave(save);
        } else {
            if (window.confirm("Are you sure you want to overwrite the selected save game?")) {
                Game.replaceSave(save, index);
            } else {
                return;
            }
        }
        this.props.onClose();
    }
    delete(index: number) {
        const listSave = Game.listSaves()[index];
        if (window.confirm("Are you sure you want to remove the save " + Game.gameSaveDisplayName(listSave) + "?")) {
            Game.deleteSave(index);
            this.forceUpdate();
        }
    }
    render() {

        const listSaves = Game.listSaves();
        const itemList = listSaves.reverse().map((s, i) => {
            const index = listSaves.length - i - 1;

            const display = Game.gameSaveDisplayName(s);
            return (<li key={i}><span onClick={() => { this.save(index) }}>{display}</span> <i className="glyphicon glyphicon-trash text-danger" onClick={() => { this.delete(index) }} /></li>);
        });
        itemList.splice(0, 0, (<li key="new" onClick={() => { this.save(-1) }}><span>New save</span></li>));
        itemList.splice(1, 0, (<li key="cancel" onClick={() => { this.props.onClose() }}><span>Cancel</span></li>));
        return (
            <div className="container">
                    <div className="col-md-8 col-md-offset-2 p-t-90">
                        <div id="mainMenu">
                            <div className="content-box">
                                <div className="logo" />
                                <h1>Save Game</h1>
                                <ul className="saveGames">{itemList}</ul>
                            </div>
                        </div>
                    </div>
                </div>
                );
    }
}
